import { Nullable } from 'utils/types';

export type CommissionTermsGetResponse = {
  id: number;
  type: string;
  name: string;
  fee: Nullable<number>;
  upfrontFee: Nullable<number>;
  ongoingFee: Nullable<number>;
  feeEndDate: Nullable<string>;
  products: Array<string>;
};

export type CommissionTermsCreateResponse = {
  id: number;
};

export type CommissionTermsPostPayload = {
  type: string;
  name: string;
  fee: Nullable<number>;
  upfrontFee: Nullable<number>;
  ongoingFee: Nullable<number>;
  feeEndDate: Nullable<string>;
  products: Array<string>;
};

export type CommissionTermsUpdatePayload = Omit<CommissionTermsPostPayload, 'type'>;

export type CommisssionTermsUpdatePayload = CommissionTermsPostPayload;

export type CommissionTermsUpdateResponse = {};

export type ProductResponseData = Product[];

export type CommissionsResponseData = Commission[];

type Product = {
  id: number;
  code: string;
  product: string;
  fixRateTerm: string;
  fixRateTermYears: number;
  isLifetime: boolean;
  intRate: number;
  maxLtv: number;
  startAgeBand: number;
  endAgeBand: number;
  svr: number;
  productFee: number;
  aprc: number;
  loanPurpose: string;
  revertMargin: number;
  type: string;
  tier: string;
};

type Commission = {
  id: number;
  name: string;
  type: string;
};

export enum COMMISSION_TERM_TYPE {
  STANDARD = 'STANDARD',
  ONGOING = 'ONGOING',
  ENHANCED = 'ENHANCED',
}

export enum COMMISSION_TERM_TYPE_LABEL {
  STANDARD = 'Standard',
  ONGOING = 'Ongoing',
  ENHANCED = 'Enhanced up-front',
}
